import React from 'react';

export const Impressum: React.FC = () => {
  return (
    <div className="prose max-w-none text-sm text-gray-600">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Impressum</h2>
      <h3 className="font-bold mt-4">Angaben gemäß § 5 DDG für track by track GmbH</h3>
      
      <p className="mt-2">
        <strong>Betreiber</strong><br />
        track by track GmbH<br />
        Schliemannstr. 23<br />
        10437 Berlin
      </p>

      <p className="mt-2">
        <strong>Vertreten durch:</strong><br />
        Tobias Sander
      </p>

      <p className="mt-2">
        <strong>Kontakt</strong><br />
        Telefon: 030403665430<br />
        Telefax: 030403665450<br />
        E-Mail: info@famefact.com
      </p>
      
      <p className="mt-2">
        DUNS-Nummer: 34-024-8055
      </p>

      <p className="mt-2">
        <strong>Registereintrag</strong><br />
        Eintragung im Handelsregister.<br />
        Registergericht: Amtsgericht Berlin-Charlottenburg<br />
        Registernummer: HRB 129805 B
      </p>

      <p className="mt-2">
        <strong>Umsatzsteuer</strong><br />
        Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
        DE814954842
      </p>

      <p className="mt-2">
        <strong>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</strong><br />
        Tobias Sander<br />
        Schliemannstr. 23<br />
        10437 Berlin
      </p>

      <p className="mt-2">
        <strong>Streitschlichtung</strong><br />
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    </div>
  );
};

export const Haftungsausschluss: React.FC = () => {
  return (
    <div className="prose max-w-none text-sm text-gray-600 mt-8">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Haftungsausschluss (Disclaimer)</h2>
      
      <h3 className="font-bold mt-4">Haftung für Inhalte</h3>
      <p>
        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
      </p>

      <h3 className="font-bold mt-4">Haftung für Links</h3>
      <p>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
      </p>

      <h3 className="font-bold mt-4">Urheberrecht</h3>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
      </p>
    </div>
  );
};